// The same company has "Drinks" in more than one menu, so a category is
// shown with its menu: "Drinks (Lunch)". Mirrors the API's categoryNames.

export const byId = (list) =>
  Object.fromEntries((list || []).map((x) => [x.id, x]));

// The API drops categories with a blank name from its lookup; so do we.
const hasName = (category) => !!category && !!(category.name || '').trim();

const compare = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' });

export const categoryOptionLabel = (category, menusById) => {
  const name = (category?.name || '').trim();
  const menuName = (menusById?.[category?.menuid]?.name || '').trim();
  return menuName ? `${name} (${menuName})` : name;
};

export const profileCategoryLabels = (categoryids, categoriesById, menusById) => {
  if (!categoryids || categoryids.length === 0) return '-';
  const labels = categoryids
    .map((id) => categoriesById?.[id])
    .filter(hasName)
    .map((c) => categoryOptionLabel(c, menusById));
  return labels.length ? labels.join(', ') : '-';
};

// True when a saved profile lists categories but none of them is still active
// (deleted or blank-named): the kitchen printer using it prints nothing. An
// empty or missing list is not this case, the form never saves one.
export const profileHasNoActiveCategories = (categoryids, categoriesById) =>
  Array.isArray(categoryids) &&
  categoryids.length > 0 &&
  !categoryids.some((id) => hasName(categoriesById?.[id]));

// Select options ordered by menu name, then category name (case-insensitive),
// so one menu's categories sit together. Categories whose menu is unknown or
// blank sort first. Does not mutate its input.
export const sortedCategoryOptions = (categories, menusById) => {
  const menuName = (c) => (menusById?.[c.menuid]?.name || '').trim();
  return (categories || [])
    .filter(hasName)
    .sort(
      (a, b) =>
        compare(menuName(a), menuName(b)) ||
        compare(a.name.trim(), b.name.trim())
    )
    .map((c) => ({ label: categoryOptionLabel(c, menusById), value: c.id }));
};
